import { useNavigate, useSearchParams } from 'react-router-dom';
import { PiAppStoreLogoDuotone, PiGooglePlayLogoDuotone } from 'react-icons/pi';
import RegistrationBackground from 'components/RegistrationBackground';
import { FeedbackPanel } from 'components/FeedbackModal';

export default function RegistrationFeedbackPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const requestedJobId = Number(searchParams.get('jobId'));
    const hasJobApplication = Number.isSafeInteger(requestedJobId) && requestedJobId > 0;

    const actions = (
        <button
            type="button"
            onClick={() => navigate('/bejelentkezes')}
            className="form-action-button form-action-primary flex-1"
        >
            Belépés
        </button>
    );

    return (
        <RegistrationBackground>
            <FeedbackPanel
                tone="success"
                title={hasJobApplication ? 'Sikeres regisztráció és jelentkezés!' : 'Sikeres regisztráció!'}
                message={hasJobApplication
                    ? 'Felhasználói fiókod elkészült, és sikeresen jelentkeztél a kiválasztott diákmunkára. Kollégáink hamarosan keresni fognak.'
                    : 'Felhasználói fiókod elkészült, mostantól belépés után egy kattintással jelentkezhetsz diákmunkáinkra.'}
                actions={actions}
            >
                <div className="mt-6 border-t border-neutral-200 pt-5 text-center">
                    <p className="font-black text-neutral-900">
                        Letöltötted már a Fürge Diák alkalmazását?
                    </p>

                    <p className="mt-2 text-sm leading-relaxed text-neutral-600">
                        Értesülj elsőként a munkalehetőségekről, és jelentkezz egy kattintással!
                    </p>

                    <div className="mt-5 flex justify-center gap-4">
                        <a
                            href="https://apps.apple.com/hu/app/f%C3%BCrge-di%C3%A1k-iskolasz%C3%B6vetkezet/id6466312233"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex size-14 items-center justify-center rounded-2xl bg-neutral-900 text-white shadow-lg transition hover:-translate-y-0.5 hover:bg-green-800"
                        >
                            <PiAppStoreLogoDuotone className="size-10 text-white" />
                        </a>

                        <a
                            href="https://play.google.com/store/search?q=f%C3%BCrge+di%C3%A1k&c=apps"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex size-14 items-center justify-center rounded-2xl bg-neutral-900 text-white shadow-lg transition hover:-translate-y-0.5 hover:bg-green-800"
                        >
                            <PiGooglePlayLogoDuotone className="size-10 text-white" />
                        </a>
                    </div>
                </div>
            </FeedbackPanel>
        </RegistrationBackground>
    );
}
